import { render, staticRenderFns } from "./preacticeDialog.vue?vue&type=template&id=1162077c&scoped=true"
import script from "./preacticeDialog.vue?vue&type=script&lang=js"
export * from "./preacticeDialog.vue?vue&type=script&lang=js"
import style0 from "./preacticeDialog.vue?vue&type=style&index=0&id=1162077c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1162077c",
  null
  
)

export default component.exports